export default function iriToId(string: string) {
  return string.substring(string.lastIndexOf('/') + 1);
}
